var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:['card-wrapper', _vm.isMobile ? '' : 'desktop']},[_c('div',{class:[
      'card-item',
      _vm.displayModeClassName,
      'flex-col-center',
      _vm.active === _vm.item.id ? 'active' : '',
    ],on:{"click":function($event){return _vm.packageClick(_vm.item)}}},[_c('div',{staticClass:"account-balance flex-col-center"},[_c('p',{staticClass:"amount flex-center"},[_vm._v("\n        "+_vm._s(_vm._f("formatNumber")(_vm.item.originalPrice,_vm.region))+"\n        "),_c('img',{attrs:{"src":require(`@/assets/images/wallet/T-coin.png`)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }